/** @format */

import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  refundStatusState: "",
  jobIdState: "",
  fromDateState: "",
  toDateState: "",
  clearFilterFlag: 0,
};

const RefundFilterSlice = createSlice({
  name: "jobFilter",
  initialState,
  reducers: {
    getRefundStatus(state, action) {
      state.refundStatusState = action.payload;
    },
    getJobId(state, action) {
      state.jobIdState = action.payload;
    },
    getFromDate(state, action) {
      state.fromDateState = action.payload;
    },
    getToDate(state, action) {
      state.toDateState = action.payload;
    },
    getClearFilterFlag(state, action) {
      state.clearFilterFlag = action.payload;
    },
    reset(state) {
      state.refundStatusState = "";
      state.jobIdState = "";
      state.fromDateState = "";
      state.clearFilterFlag = 0;
      state.toDateState = "";
    },
  },
});

export const {
  getRefundStatus,
  getJobId,
  getFromDate,
  getToDate,
  getClearFilterFlag,
  reset,
} = RefundFilterSlice.actions;

export default RefundFilterSlice.reducer;
